import React from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash.isequal';

import {
    requestLoadSprayedEntitiesByDate,
    canceledLoadSprayedEntitiesByDate
} from 'services/sprayedEntitiesByDate/actions';
import { SprayedEntitiesByDateRequestProps } from 'services/sprayedEntitiesByDate/types';

interface OwnProps {
    namespace: string;
}

interface DispatchProps {
    requestLoadSprayedEntitiesByDate: typeof requestLoadSprayedEntitiesByDate;
    canceledLoadSprayedEntitiesByDate: typeof canceledLoadSprayedEntitiesByDate;
}

type Props = OwnProps & SprayedEntitiesByDateRequestProps & DispatchProps;

export class SprayedEntitiesByDateRequestComponent extends React.PureComponent<
    Props
> {
    componentDidMount(): void {
        const { props } = this;

        if (props.startDate) {
            props.requestLoadSprayedEntitiesByDate(props.startDate);
        }
    }

    componentDidUpdate(prevProps: Props): void {
        const { props } = this;
        if (!isEqual(prevProps.startDate, props.startDate) && props.startDate) {
            props.requestLoadSprayedEntitiesByDate(props.startDate);
        }
    }

    componentWillUnmount(): void {
        const { props } = this;
        props.canceledLoadSprayedEntitiesByDate();
    }

    render(): null {
        return null;
    }
}

export default connect(null, {
    requestLoadSprayedEntitiesByDate,
    canceledLoadSprayedEntitiesByDate
})(SprayedEntitiesByDateRequestComponent);
